import {FormHelperText, Typography} from '@mui/material';
import {FC} from 'react';

export const FormHelper: FC<{ helperText: string; hasError?: boolean }> = ({helperText, hasError = false}) => (
    <FormHelperText error={hasError}>
        <Typography variant="caption" sx={{color: hasError ? 'error.main' : '#666'}}>
            {helperText}
        </Typography>
    </FormHelperText>
);
